import axios from "axios";

import { $apiEndpoints } from '../services/config';

export const getPatientRef = async (id) => {
  try {
    const domain = process.env.VUE_APP_DOMAIN + "/api/v1";
    const response = await axios.get(domain + `/patients/${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};
